import React from 'react';

import { IComponent } from '../../../typings/generic-component';
import { CtaTarget } from '../../../typings/match-row';
import { makeClassNames } from '../../../utils/styles';
import { objectToDataAttributes } from '../../../utils/tracking-data';

import './text.scss';

export type TextTags = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'p' | 'label' | 'a';
export const tagList: TextTags[] = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'p', 'label', 'a'];

const LINK_TAG: TextTags = 'a';
const LABEL_TAG: TextTags = 'label';

export interface IText extends IComponent {
  forId?: string;
  href?: string;
  tag?: TextTags;
  target?: CtaTarget;
}

const classNames = ({
  color,
  fontSize,
  tag,
  fontWeight,
}: {
  color?: string;
  fontSize?: string;
  tag?: string;
  fontWeight?: string;
}) =>
  makeClassNames({
    text: [
      'text',
      `text--${tag}`,
      color && `text--color-${color}`,
      fontSize && `text--font-size-${fontSize}`,
      fontWeight && `text--weight-${fontWeight}`,
    ],
  });

const Text = ({
  /* istanbul ignore next: default value */ className = '',
  /* istanbul ignore next: default value */ dataAttributes = {},
  /* istanbul ignore next: default value */ tag = 'span',
  children,
  color,
  fontSize,
  fontWeight,
  forId,
  href,
  target,
}: IText) => {
  const cn = classNames({ color, fontSize, tag, fontWeight });

  const Tag = tag as keyof JSX.IntrinsicElements;
  const props: { htmlFor?: string; href?: string; target?: CtaTarget } = {};
  if (tag === LABEL_TAG && forId) {
    props.htmlFor = forId;
  }
  if (tag === LINK_TAG && href) {
    props.href = href;
    props.target = target;
  }

  return (
    // @ts-expect-error converting string to tag
    <Tag className={`${cn.text} ${className}`} {...props} {...objectToDataAttributes(dataAttributes)}>
      {children}
    </Tag>
  );
};

export default Text;
